module.exports = __webpack_public_path__ + "arrow_left.270f72df47e036d9cfa1.svg";


//////////////////
// WEBPACK FOOTER
// ./~/angular-bootstrap-md/img/svg/arrow_left.svg
// module id = 387
// module chunks = 2